export default "__VITE_ASSET__0pVZ25Ph__"